/**
 * EC: user is already registered with another Program other than SPP/TPP like APC
 * DC: user is already registered with another Program | dc-registered-with-another-program
 */
import React, { useMemo } from "react";
import DxpPageShell from "../Common/StandaloneFormViews/DxpPageShell";
import {
  createDxpClickHandler,
  getUserData,
  getDXPRegistrationLink,
} from "../../Helpers/utils";
import { ALREADY_REGISTERED_LABEL } from "../../Helpers/constants";
import useBackButtonOverride from "../../Hooks/useBackButtonOverride";

import {
  DxpBodyText,
  DxpHeading,
  DxpMessageCard,
  DxpNarrowColumn,
} from "../dxpStandaloneUi";
import DxpRegistrationTopHeader from "../DxpRegistrationTopHeader";

const PROGRAM = "DXP";

function RegisteredWithAnotherProgram({ appType }: { appType?: string }) {
  useBackButtonOverride(getDXPRegistrationLink());

  const onAction = useMemo(() => createDxpClickHandler(), []);

  const email = getUserData()?.email || localStorage.getItem("email") || "";
  const alreadyWith = localStorage.getItem("alreadyRegisteredWith") || "DXP";
  const label =
    (ALREADY_REGISTERED_LABEL as Record<string, string>)[alreadyWith] ||
    alreadyWith;

  return (
    <>
      <DxpRegistrationTopHeader program={PROGRAM} />

      <DxpPageShell appType={appType} requireCommonHeaders>
        <div className="dxp-static-message-outer">
          <DxpNarrowColumn>
            <DxpMessageCard>
              <DxpHeading>
                You are registered to another Adobe partner program
              </DxpHeading>
              <DxpBodyText>
                An email address can belong to one Adobe partner program at a
                time. You are using{" "}
                <span className="dxp-text-strong-dark">{email}</span> for{" "}
                <span className="dxp-text-strong-dark">{label}</span> program.
              </DxpBodyText>
              <p className="dxp-body-text-row-actions">
                <button
                  type="button"
                  className="dxp-plain-text-link"
                  onClick={() => onAction({ actionType: "goBack" })}
                >
                  Go back
                </button>{" "}
                and use another email address or{" "}
                <button
                  type="button"
                  className="dxp-plain-text-link"
                  onClick={() => onAction({ actionType: "contactSupport" })}
                >
                  contact support
                </button>
                .
              </p>
            </DxpMessageCard>
          </DxpNarrowColumn>
        </div>
      </DxpPageShell>
    </>
  );
}

export default RegisteredWithAnotherProgram;
